import amplitude, { type AmplitudeClient } from 'amplitude-js';

import { isBrowser } from '@lib/environment/isBrowser';

export const getAmplitudeInstance = (): AmplitudeClient | null =>
  isBrowser() ? amplitude.getInstance() : null;
